module.exports = __webpack_public_path__ + "img/White_TaleMaker.41406833.png";